import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "footer-navigation",
  templateUrl: "./footer-navigation.component.html",
  styleUrls: ["./footer-navigation.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterNavigationComponent {
  @Input() nextButtonText: string = "Next";
  @Input() nextButtonColor: string = "primary";
  @Input() showFirstButton: boolean = false;
  @Input() firstButtonText: string;
  @Input() footerMessage: string;
  @Input() hideFooterMessage: boolean = false;
  @Input() hideBackButton: boolean = false;
  @Input() firstButtonDisable: boolean = false;
  @Input() nextButtonDisable = false;
  @Input() loadingIndicator = false;
  @Input() componentName:string;
  @Output() movePrevious = new EventEmitter();
  @Output() firstButtonEvent = new EventEmitter();
  @Output() moveNext = new EventEmitter();
}
